import React,{useState} from 'react'
import Routes from "./Routes"
import { Navbar, Nav, Container, Row, Button,FormControl,Form,Col,Toast, Card, Jumbotron} from "react-bootstrap";

function App() {
  return (
    <div className="App">
       {/* <Navbar bg="dark" variant="dark" >
              <Container style={{align:"center"}}>
                <Navbar.Brand  href="#home">Team WebGeeks</Navbar.Brand>
              </Container>
      </Navbar> */}
      <Routes />
    </div>
  )
}

export default App

